import { applyUsableFilters, generateErrors } from 'utilities/util';
import { ThunkDispatch } from 'redux-thunk';
import { IStore } from 'reducers/index';
import { Action } from 'redux';
import { TYPES as FILTER_TYPES } from 'action-types/filters';
import { TYPES } from 'action-types/cbl';
import { callApiV2Post, callApiV2Get } from 'utilities/apiCaller';
import API from 'constants/api';

export const resetCBL = () => {
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({ type: TYPES.RESET_CBL.PENDING });
        dispatch({ type: FILTER_TYPES.SET_TOTAL_COUNT, totalCount: 0 });
        dispatch({ type: TYPES.RESET_CBL.FULFILLED, response: [] });
    }
};
export const resetCBLDetails = () => {
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({ type: TYPES.RESET_CBL_DETAILS });
    }
};
export const searchCBL = (pageNumber?: number, pageSize?: number, genericFilter?: string) => {
    return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
        dispatch({ type: TYPES.SEARCH_CBL.PENDING });
        try {
            const res = await callApiV2Post(API.CBL.CblSearch,
                applyUsableFilters(getState, {
                    Page: pageNumber,
                    PageSize: pageSize
                }), {});
            dispatch({ type: FILTER_TYPES.SET_TOTAL_COUNT, totalCount: res.data.totalCount });
            dispatch({ type: TYPES.SEARCH_CBL.FULFILLED, response: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.SEARCH_CBL.REJECTED, errors });
        }
    }
};
export const GetCBLDetails = (cblId: number) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.CBL_DETAILS.PENDING });
        try {
            const res = await callApiV2Get(`${API.CBL.CblDetails}/${cblId}`, {}, {});
            dispatch({ type: TYPES.CBL_DETAILS.FULFILLED, details: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.CBL_DETAILS.REJECTED, errors });
        }
    }
};